import React, {useContext} from 'react';
import {AgentContext} from "../../context/agent-context.jsx";
import {Card} from "../../../../../../components/card/card.jsx";
import InputForm from "../../../../../../components/input/input-form.jsx";

const Clothes = () => {
    const {handleInputObject, user} = useContext(AgentContext);

    return (
        <div className={"h-[calc(100vh-131px)] overflow-x-hidden overflow-y-auto"}>
            <Card>
                <Card.Header>
                    <Card.Title>Vestuário</Card.Title>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-3">
                            <InputForm id="helmet" value={user.clothes.helmet} label="Boina, bibico, capacete"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="jacket" value={user.clothes.jacket} label="Blusa, jaqueta, camiseta, gandola"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="bulletproofVest" value={user.clothes.bulletproofVest} label="Colete balístico (número e tamanho)"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="militaryBracer" value={user.clothes.militaryBracer} label="Braçal"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4 mb-3">
                        <div className="col-span-3">
                            <InputForm id="elbowPad" value={user.clothes.elbowPad} label="Cotoveleira"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="halfFingerGlove" value={user.clothes.halfFingerGlove} label="Luva meio dedo"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="pants" value={user.clothes.pants} label="Calça, bermuda"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="belt" value={user.clothes.belt} label="Cinturão"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-3">
                            <InputForm id="kneeBrace" value={user.clothes.kneeBrace} label="Joelheira"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="sock" value={user.clothes.sock} label="Meia"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="rainSet" value={user.clothes.rainSet} label="Conjunto de chuva"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                        <div className="col-span-3">
                            <InputForm id="shoes" value={user.clothes.shoes} label="Calçados (Bota, sapato)"
                                       onChange={(e) => handleInputObject("clothes", e)}/>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </div>
    );
};

export default Clothes;